enum StudyRoleType {
  INVESTIGATOR = 'INVESTIGATOR',
  COORDINATOR = 'COORDINATOR',
  READ_ONLY = 'READ_ONLY',
  SUBJECT = 'SUBJECT',
  UNKNOWN = 'UNKNOWN',
}

export default StudyRoleType;
